'use strict';

module.exports = require('./compile/defaults');